module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/default-borders-active.7db2358f.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/default-borders-active.png
// module id = 2573
// module chunks = 11